import { createIsomorphicFn } from "@tanstack/react-start"

import { getSupabaseBrowserClient } from "./browser-client"
import { getSupabaseServerClient } from "./server-client.server"

export const getIsomorphicSupabaseClient = createIsomorphicFn()
  .server(async () => getSupabaseServerClient())
  .client(async () => getSupabaseBrowserClient())
